import MobilePopularSearchPanel from "./mobile-popular-search-panel";
import MobileSearchNearbyCard from "./mobile-search-nearby-card";
import MobileSearchResults from "./mobile-search-results";

const MobileSearchOverlayBody = ({
  trimmedSearch,
  hasTypedSearch,
  suggestionState,
  searchActions,
}) => {
  const { routeToSearch, routeToBestSearchTarget, routeToPlace } = searchActions;
  const {
    nearbyOnly,
    setNearbyOnly,
    userLocation,
    isSuggestionLoading,
    popularItems,
    popularUpdatedAt,
    topPlace,
    placeSuggestions,
    matchedRecentTerms,
    suggestionTerms,
  } = suggestionState;
  const visiblePlaceSuggestions =
    Array.isArray(placeSuggestions) && placeSuggestions.length > 0
      ? placeSuggestions
      : topPlace
        ? [topPlace]
        : [];

  return (
    <div className="px-4 pt-3">
      <MobileSearchNearbyCard
        nearbyOnly={nearbyOnly}
        setNearbyOnly={setNearbyOnly}
      />

      {hasTypedSearch ? (
        <MobileSearchResults
          trimmedSearch={trimmedSearch}
          topPlace={topPlace}
          visiblePlaceSuggestions={visiblePlaceSuggestions}
          matchedRecentTerms={matchedRecentTerms}
          suggestionTerms={suggestionTerms}
          userLocation={userLocation}
          isSuggestionLoading={isSuggestionLoading}
          onSubmit={routeToBestSearchTarget}
          onPlaceClick={routeToPlace}
        />
      ) : (
        <MobilePopularSearchPanel
          popularItems={popularItems}
          updatedAt={popularUpdatedAt}
          onSubmit={routeToSearch}
        />
      )}
    </div>
  );
};

export default MobileSearchOverlayBody;
